import { t } from "i18next";
import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Club } from "../../../../interfaces/club";
import { Athlete, AthleteTeamSeason } from "../../../../interfaces/athlete";
import { getAthlete } from "../../../../services/athlete";
import { ManagementAthleteEdit } from "./athlete-edit";
import moment from 'moment';
import { getClubOptions } from "../../../../services/club";
import avatar from "../../../../assets/images/avatar.svg";
import { ManagementAthleteMeasurement } from "./athlete-measurement";
import { Link } from "react-router-dom";
import { LoadingSpinner } from "../../../general/loading-spinner";

export function ManagementAthleteList() {
    const [athletes, setAthletes] = useState<Athlete[]>([]);
    const [clubOptions, setClubOptions] = useState<any[]>([]);
    const [showAddNew, setShowAddNew] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showMeasurement, setShowMeasurement] = useState(false);
    const [selectedId, setSelectedId] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMoreAthletes, setHasMoreAthletes] = useState(true);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedClub, setSelectedClub] = useState('');
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        getClubOptions()
            .then(response => {
                setClubOptions(response.data);
            })
            .catch(error => {
                console.log(error);
            });
        getAthlete('', '', '', '', 'changed_at', 'DESC', 1, 12)
            .then(response => {
                setAthletes(response.data);
                setHasMoreAthletes(response.data.length === 12);
                setCurrentPage(1);
                setLoaded(true);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSearchSubmit = (event: any) => {
        event.preventDefault();

        const s = event.target.search.value;
        const club = event.target.club.value;

        setSearchTerm(s);
        setSelectedClub(club);

        getAthlete(s, club, '', '', 'changed_at', 'DESC', 1, 12)
            .then(response => {
                setAthletes(response.data);
                setHasMoreAthletes(response.data.length === 12);
                setCurrentPage(1);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleAddNew = (event: any) => {
        event.preventDefault();
        setShowAddNew(true)
    }

    const handleAddNewOnSave = (s: Athlete) => {
        const newAthletes = [
            s,
            ...athletes
        ];
        setAthletes(newAthletes);
        setShowAddNew(false);
    }

    const handleAddNewOnClose = () => {
        setShowAddNew(false);
    }

    /*const handleDelete = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowDelete(true);
    }*/

    /*const handleDeleteOnDelete = (id: number) => {
        setSelectedId(0);
        const newAthletes = athletes.filter((m: Athlete) => m.id != id);
        setAthletes(newAthletes);
        setShowDelete(false);
    }*/

    /*const handleDeleteOnClose = () => {
        setSelectedId(0);
        setShowDelete(false);
    }*/

    const handleEdit = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowEdit(true);
    }

    const handleEditOnSave = (changedAthlete: Athlete) => {
        setSelectedId(0);
        const newAthletes = athletes.map((m: Athlete) => {
            if (m.id == changedAthlete.id) {
                return changedAthlete;
            } else {
                return m;
            }
        });
        setAthletes(newAthletes);
        setShowEdit(false);
    }

    const handleEditOnClose = () => {
        setSelectedId(0);
        setShowEdit(false);
    }

    const handleMeasurement = (event: any) => {
        event.preventDefault();
        setSelectedId(event.currentTarget.dataset.id);
        setShowMeasurement(true);
    }

    const handleMeasurementOnSave = (changedAthlete: Athlete) => {
        setSelectedId(0);
        /*const newAthletes = athletes.map((m: Athlete) => {
            if (m.id == changedAthlete.id) {
                return changedAthlete;
            } else {
                return m;
            }
        });
        setAthletes(newAthletes);*/
        setShowMeasurement(false);
    }

    const handleMeasurementOnClose = () => {
        setSelectedId(0);
        setShowMeasurement(false);
    }

    const handleLoadMore = () => {
        if (isLoadingMore || !hasMoreAthletes) return;

        setIsLoadingMore(true);
        const nextPage = currentPage + 1;

        getAthlete(searchTerm, selectedClub, '', '', 'changed_at', 'DESC', nextPage, 12)
            .then(response => {
                setAthletes(prevAthletes => [...prevAthletes, ...response.data]);
                setCurrentPage(nextPage);
                setHasMoreAthletes(response.data.length === 12);
                setIsLoadingMore(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoadingMore(false);
            });
    }

    return (
        <div className="athletes-list-container">
            <h1>
                { t('athletes')}
            </h1>
            { !loaded && <LoadingSpinner /> }
            { loaded &&
                <div className="filters-container">
                <Form onSubmit={ handleSearchSubmit }>
                    <Form.Group className="field-search" controlId="search">
                        <Form.Control type="text" placeholder={ t("Write to search") } />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="club_id">
                        <Form.Select aria-label={ t("club") } name="club">
                            <option value="">{ t("select_club") }</option>
                            { clubOptions.map((c: Club) => {
                                return <option key={ 'club-' + c.id } value={ c.id }>{ c.name }</option>;
                            })}
                        </Form.Select>
                    </Form.Group>
                    <div className="actions">
                        <Button variant="primary" type="submit">
                            { t("search") }
                        </Button>
                    </div>
                </Form>
                </div>
            }
            { loaded &&
                <div className="grid-container">
                <Row>
                    { athletes.map((a: Athlete) => {
                        return <Col key={ 'athlete-' + a.id } xs={12} md={6} lg={4}>
                            <div className="athlete-card">
                                <div className="heading">
                                    <div className="avatar">
                                        { a.avatar.length > 0 &&
                                            <img src={ a.avatar[0].url } alt={ a.name } />
                                        }
                                        { a.avatar.length == 0 &&
                                            <img src={ avatar } alt={ a.name } />
                                        }
                                    </div>
                                    <div className="meta">
                                        <div className="name">
                                            <Link to={ '/athletes/' + a.id + '/view' } title={ a.name }>{ a.name }</Link>
                                        </div>
                                        { a.birthdate && (
                                            <div className="years">
                                                { moment(new Date()).diff(a.birthdate, 'years') + ' ' + t("years").toLowerCase() }
                                            </div>
                                        )}
                                        <div className="team">
                                            {
                                               a.registered_in.map((ats: AthleteTeamSeason) => {
                                                    return ats.club_name + '/' + ats.team_name;
                                                }).join(', ')
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="actions">
                                    <a href="#" className="icon-link edit" title={ t("edit") } onClick={ handleEdit } data-id={ a.id }>
                                        <i className="bi bi-pencil-square"></i>
                                    </a>
                                    <a href="#" className="icon-link measurement" title={ t("edit") } onClick={ handleMeasurement } data-id={ a.id }>
                                        <i className="bi bi-clipboard-data"></i>
                                    </a>
                                    {/*<a href="#" className="icon-link delete" title={ t("Delete") } onClick={ handleDelete } data-id={ a.id }>
                                        <i className="bi bi-trash"></i>
                                    </a>*/}
                                </div>
                            </div>
                        </Col>
                    })}
                </Row>
                { hasMoreAthletes && (
                    <Row className="mt-4">
                        <Col className="text-center">
                            <Button
                                variant="outline-primary"
                                onClick={handleLoadMore}
                                disabled={isLoadingMore}
                            >
                                {isLoadingMore ? t('loading') + '...' : t('Load more')}
                            </Button>
                        </Col>
                    </Row>
                )}
                </div>
            }
            {/*<a className="admin-add-new" href="#" onClick={ handleAddNew }>
                <i className="bi bi-plus-circle"></i>
            </a>*/}
            {/* showAddNew &&
                <AdminAthleteNew onSave={ handleAddNewOnSave } onClose={ handleAddNewOnClose } />
            */}
            { showEdit && (selectedId != 0) &&
                <ManagementAthleteEdit id={ selectedId } onSave={ handleEditOnSave } onClose={ handleEditOnClose } />
            }
            { showMeasurement && (selectedId != 0) &&
                <ManagementAthleteMeasurement id={ selectedId } onSave={ handleMeasurementOnSave } onClose={ handleMeasurementOnClose } />
            }
            {/* showDelete && (selectedId != 0) &&
                <AdminAthleteDelete id={ selectedId } onDelete={ handleDeleteOnDelete } onClose={ handleDeleteOnClose } />
            */}
        </div>

    )
}